import { defineComponent as t, openBlock as o, createElementBlock as r, normalizeClass as a, createElementVNode as l, renderSlot as i } from "vue";
const n = ["src", "alt"], d = ["src", "alt"], m = /* @__PURE__ */ t({
  __name: "Web3authFooter",
  props: {
    lightLogo: { default: "https://images.web3auth.io/ws-trademark-light.svg" },
    darkLogo: { default: "https://images.web3auth.io/ws-trademark-dark.svg" },
    alt: { default: "web3auth logo" },
    classes: { default: () => ({}) },
    reverseDir: { type: Boolean, default: !1 }
  },
  setup(c) {
    return (e, u) => {
      var s;
      return o(), r("div", {
        class: a(["w-full flex flex-col items-center justify-center gap-2", { "flex-col-reverse": e.reverseDir }, e.classes.container])
      }, [
        l("img", {
          src: e.lightLogo,
          alt: e.alt,
          class: a(["block dark:hidden", (s = e.classes) == null ? void 0 : s.img])
        }, null, 10, n),
        l("img", {
          src: e.darkLogo,
          alt: e.alt,
          class: "hidden dark:block"
        }, null, 8, d),
        i(e.$slots, "default")
      ], 2);
    };
  }
});
export {
  m as _
};
//# sourceMappingURL=Web3authFooter.vue_vue_type_script_setup_true_lang-DI53-S5i.js.map
